import React, { useEffect, useState } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';

import { Add, BeenhereRounded } from '@material-ui/icons';

import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';

import { wsFindBy } from 'services/WService.js';
import { WithApp } from 'contexts/appContext';
import FilterCustom from 'components/Tvendo/Common/FilterCustom';
import GridItem from 'components/Grid/GridItem';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import { currency } from 'hooks/Pipe';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
};

const useStyles = makeStyles(styles);
const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 90 },
  { Header: 'Origen', accessor: 'origin', width: 100 },
  { Header: 'Gúia', accessor: 'is_guide', width: 100 },
  { Header: 'T. Comprobante', accessor: 'ReceiptType', width: 140 },
  { Header: 'Serie sunat', accessor: 'ReceiptSerie', width: 130 },
  { Header: 'Núm. sunat', accessor: 'ReceiptNumber', width: 130 },
  { Header: 'Fecha', accessor: 'created_at', width: 150 },
  { Header: 'Cód. Producto', accessor: 'ItemCode', width: 130 },
  { Header: 'Nombre Producto', accessor: 'ItemName' },
  { Header: '# Pza.', accessor: 'NumPerMsr', width: 100 },
  { Header: 'U/Mj', accessor: 'UnitMsr', width: 100 },
  { Header: 'Price', accessor: 'price', width: 100 },
  { Header: 'Últ. precio', accessor: 'last_purchase_price', width: 100 },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 }
];
export default WithApp(function PriceDiff(props) {
  const classes = useStyles();
  const [priceDiff, setPriceDiff] = useState([]);
  const [valueSearch, setValueSearch] = useState({});
  const [dataLoading, setDataLoading] = useState(false);

  async function listPriceDiff() {
    setDataLoading(true);
    let response = await wsFindBy('purch/purchase/price-differences', valueSearch);
    setDataLoading(false);
    if (response.success) setPriceDiff(response.data);
  }

  useEffect(() => {
    if (valueSearch.start_date) listPriceDiff(valueSearch);
  }, [valueSearch]);

  return (
    <Card>
      <CardHeader icon>
        <AllowedGuard
          permission={ConstantPermissions.LOGI_FAMILIES_STORE}
          component={
            <CardIcon color="primary">
              <BeenhereRounded style={{ color: 'white' }} />
            </CardIcon>
          }
        >
          <CardIcon pointer="true" color={props.themeContext.buttonColorSuccess}>
            <Add />
          </CardIcon>
        </AllowedGuard>
        <h4 className={classes.cardIconTitle}>Listado de diferencia de precios {dataLoading && <LoadingSpinner />}</h4>
      </CardHeader>
      <CardBody>
        <FilterCustom
          getFilter={setValueSearch}
          dateRange
          component={
            <>
              <GridItem xs={12} md={2}>
                <FormControl fullWidth margin="normal">
                  <InputLabel>Origen</InputLabel>
                  <Select
                    value={valueSearch.is_guide || ''}
                    inputProps={{ name: 'origin' }}
                    onChange={(e) => setValueSearch({ ...valueSearch, origin: e.target.value })}
                  >
                    <MenuItem value="I">Importado</MenuItem>
                    <MenuItem value="M">Manual</MenuItem>
                  </Select>
                </FormControl>
              </GridItem>
              <GridItem xs={12} md={2}>
                <FormControl fullWidth margin="normal">
                  <InputLabel>Guía</InputLabel>
                  <Select
                    value={valueSearch.is_guide || ''}
                    inputProps={{ name: 'is_guide' }}
                    onChange={(e) => setValueSearch({ ...valueSearch, is_guide: e.target.value })}
                  >
                    <MenuItem value="Y">Si</MenuItem>
                    <MenuItem value="N">No</MenuItem>
                  </Select>
                </FormControl>
              </GridItem>
            </>
          }
        />

        <ReactTable
          excelName="Diferencia_precios"
          defaultWidth={1700}
          columns={columns}
          colorRow={(item) => {
            let color = '';
            if (item.price > item.last_purchase_price) {
              color = '#ff00001f'; // rojo
            } else if (item.price < item.last_purchase_price) {
              color = '#00d11a45'; // verde
            } else {
              color = 'white';
            }
            return color;
          }}
          data={priceDiff.map((item, i) => {
            return {
              num: i + 1,
              origin: item.origin === 'I' ? 'Importado' : 'Manual',
              is_guide: item.is_guide === 'Y' ? 'Si' : 'No',
              ReceiptType: item.ReceiptType,
              ReceiptSerie: item.ReceiptSerie,
              ReceiptNumber: item.ReceiptNumber,
              created_at: item.created_at,
              ItemCode: item.ItemCode,
              ItemName: item.ItemName,
              NumPerMsr: item.NumPerMsr,
              UnitMsr: item.UnitMsr,
              price: currency(item.price),
              last_purchase_price: currency(item.last_purchase_price),
              actions: ''
            };
          })}
        />
      </CardBody>
    </Card>
  );
});
